
import { computed, defineComponent, reactive } from 'vue';
import { IOption } from '@/core/models/AntDesign/IOption';
import { IParametrosConsultaRapida } from '@/core/models/Consulta/IParametrosConsultaRapida';
import { useTelaBase } from '@/core/composables/TelaBase';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import storeSistema from '@/store/storeSistema';
import ServicoAmbiente from '@/servicos/PainelAdministrativo/ServicoAmbiente';

export default defineComponent({
  name: 'SelecionarAmbiente',
  props: {
    varios: {
      type: Boolean,
      default: false,
    },
    codigoSelecionado: {
      type: Number || undefined,
    },
    codigosSelecionados: {
      type: Array as () => number[],
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Digite para selecionar',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:codigoSelecionado', 'update:codigosSelecionados'],
  setup(props, { emit }) {
    const { montaOpcoesComListaConsultaRapida } = useTelaBase();

    let debounce = 0;
    const servicoAmbiente = new ServicoAmbiente();

    const state = reactive({
      listaAmbientes: [] as IOption[],
      fetching: false,
      emDigitacao: false,
    });

    async function obterAmbientePorCodigo(valor: any) {
      if (state.emDigitacao) { return; }
      if (!UtilitarioGeral.valorValido(valor)) { return; }
      if (!(valor > 0)) { return; }

      if (props.varios) {
        if (props.codigosSelecionados.length === 0) { return; }
      } else if (props.codigoSelecionado === 0) {
        return;
      }
      let efetuarConsulta = true;

      if (UtilitarioGeral.validaLista(state.listaAmbientes)) {
        if (props.varios) {
          const listaCodigosConsulta = state.listaAmbientes.map((c) => c.value);
          const diferencas = props.codigosSelecionados.filter((c) => !listaCodigosConsulta.includes(c));
          if (!UtilitarioGeral.validaLista(diferencas)) {
            efetuarConsulta = false;
          }
        } else {
          const existeLista = state.listaAmbientes.find((c) => c.value === props.codigoSelecionado);
          if (existeLista !== undefined) {
            efetuarConsulta = false;
          }
        }
      }

      if (!efetuarConsulta) return;

      state.listaAmbientes = [];

      const parametrosConsultaRapida: IParametrosConsultaRapida = {
        apenasAtivos: false, recursoAssociado: '',
      };

      if (props.varios) {
        parametrosConsultaRapida.filtrarPorVariosCodigos = true;
        parametrosConsultaRapida.valores = valor;
      } else {
        parametrosConsultaRapida.filtrarPorCodigo = true;
        parametrosConsultaRapida.valor = valor;
      }
      const listaAmbientes = await servicoAmbiente.consultaRapida(parametrosConsultaRapida);
      state.listaAmbientes = montaOpcoesComListaConsultaRapida(listaAmbientes);
    }

    async function pesquisarAmbiente(valorPesquisa: any) {
      state.emDigitacao = true;

      if (!UtilitarioGeral.valorValido(valorPesquisa)) { return; }

      state.listaAmbientes = [];
      clearTimeout(debounce);
      debounce = setTimeout(async () => {
        const parametrosConsultaRapida: IParametrosConsultaRapida = {
          valor: valorPesquisa, apenasAtivos: true, recursoAssociado: '',
        };

        parametrosConsultaRapida.empresas = storeSistema.getters.empresasUsuarioAutenticado();

        const listaAmbientes = await servicoAmbiente.consultaRapida(parametrosConsultaRapida);
        state.listaAmbientes = montaOpcoesComListaConsultaRapida(listaAmbientes);
      }, 600);
    }

    function obterAmbiente():any {
      obterAmbientePorCodigo(props.codigoSelecionado);
      return (props.codigoSelecionado === 0 ? undefined : props.codigoSelecionado);
    }

    const computedCodigoSelecionado = computed({
      get: () => obterAmbiente(),
      set: (val: number) => {
        emit('update:codigoSelecionado', val);
      },
    });

    function obterAmbientes():number[] {
      obterAmbientePorCodigo(props.codigosSelecionados);
      return props.codigosSelecionados;
    }

    const computedCodigosSelecionados = computed({
      get: () => obterAmbientes(),
      set: (val: number[]) => {
        emit('update:codigosSelecionados', val);
      },
    });

    return {
      props,
      state,
      pesquisarAmbiente,
      computedCodigoSelecionado,
      computedCodigosSelecionados,
    };
  },
});
